<script>
import store from '@state/store'
import values from 'lodash/values'
import Layout from '@layouts/loggedin.vue'
import { authComputed } from '@state/helpers'
import Tab from '@router/components/tab.vue'
import Tabs from '@router/components/tabs.vue'
import GroupDetail from '@adminGroups/components/detail.vue'
import GroupSettings from '@adminGroups/components/settings.vue'
import Table from '@adminGroups/components/table.vue'
import AddMembers from '@adminGroups/components/add-members.vue'
import AddEventAdmins from '@adminGroups/components/add-event-admins.vue'

export default {
  components: {
    Layout,
    Tab,
    Tabs,
    GroupDetail,
    GroupSettings,
    Table,
    AddMembers,
    AddEventAdmins,
  },
  data() {
    return {}
  },
  computed: {
    ...authComputed,
    companyId() {
      return +this.$route.params.companyId
    },
    groupId() {
      return +this.$route.params.groupId
    },
    isEditForm() {
      return !!this.groupId
    },
    groupsList() {
      return this.$store.state.adminGroups.lists || []
    },
    groupItem() {
      if (this.isEditForm) {
        if (this.$route.params.item && this.$route.params.item.id) {
          return this.$route.params.item
        } else if (this.groupsList.length) {
          return this.groupsList.find((item) => item.id === this.groupId)
        } else {
          return this.currentUser.groups.find(
            (item) => item.id === this.groupId
          )
        }
      }
      return {}
    },
  },
  methods: {
    refreshMembersTable() {
      this.$refs.membersTable.fetchData()
    },
    refreshAdminsTable() {
      this.$refs.adminsTable.fetchData()
    },
    refreshEventAdminsTable() {
      this.$refs.eventAdminsTable.fetchData()
    },
    triggerDetailTab() {
      this.$refs.tabsWrap.selectTab(0)
    },
    saveEvent(params) {
      const refsValues = values(this.$refs)
      let data = {}

      refsValues.map((component) => {
        if (component.getFormData) {
          const formData = component.getFormData()
          data = Object.assign(data, formData)
        }
      })
      if (!data.name) {
        return
      }
      if (this.isEditForm) {
        data = Object.assign({}, this.groupItem, data)
        store
          .dispatch('adminGroups/updateItem', data)
          .then(() => alert('group was succesfully updated!'))
      } else {
        data = Object.assign(data, { company_id: this.companyId, csv: false })
        store
          .dispatch('adminGroups/newItem', {
            companyId: this.companyId,
            params: { ...data },
          })
          .then(() => alert('group was succesfully created!'))
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bg-white px-7.5 pt-4 text-xl">
      <span class="">Groups</span>
      <span class="breadcrumb-separator">></span>
      <span class="text-blue">{{ isEditForm ? 'Edit' : 'New' }} Group</span>
    </div>

    <div>
      <Tabs
        ref="tabsWrap"
        :classes="'bg-white flex justify-around border-none'"
        :parent-classes="'bg-white flex justify-center'"
        :tab-classes="
          'border-b-5 pb-5 text-xl mr-16 leading-loose cursor-pointer'
        "
      >
        <Tab
          title='<svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 24.861 25.805" class="inline-block align-middle mr-1"><path id="Path_129" data-name="Path 129" d="M38.27,10.678l-12.545.031V7.5H13.41V33.305H14.5V20.224H24.636v2.925H38.271l-3.842-6.236ZM24.636,19.135H14.5V8.589H24.636ZM36.3,22.059H25.725V11.8H36.306l-3.172,5.117Z" transform="translate(-13.41 -7.5)" fill="currentColor" /></svg> <span class="align-middle">Details</span>'
        >
          <div :class="$style.tabContent" class="pt-14">
            <GroupDetail
              ref="groupDetail"
              :company-id="companyId"
              :group-item="groupItem"
              @trigger-detail-tab="triggerDetailTab"
            />
          </div>
        </Tab>
        <Tab
          v-if="isEditForm"
          title='<svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21.044 24.049" class="inline-block align-middle mr-1"><g id="Group_244" data-name="Group 244" transform="translate(-453.062 -37.45)"><path id="Path_109" data-name="Path 109" d="M463.593,50.506a6.528,6.528,0,1,0-6.529-6.528A6.546,6.546,0,0,0,463.593,50.506Zm-5.133-6.528a5.139,5.139,0,0,1,5.133-5.133l.133,0a5.135,5.135,0,1,1-5.266,5.135Z" fill="currentColor"/><path id="Path_110" data-name="Path 110" d="M463.584,50.727a10.534,10.534,0,0,0-10.522,10.522v.25h1.4v-.25a9.139,9.139,0,0,1,9.123-9.123h0a9.126,9.126,0,0,1,9.127,9.123v.25h1.15v-.25h.24A10.534,10.534,0,0,0,463.584,50.727Z" fill="currentColor"/></g></svg> <span class="align-middle">Group Members</span>'
        >
          <div :class="$style.tabContent" class="pt-4">
            <Table
              ref="membersTable"
              :company-id="companyId"
              :group-id="groupId"
              :no-new-btn="true"
              :no-edit-btn="true"
              table-type="USERS"
            />
            <AddMembers
              :company-id="companyId"
              :group-id="groupId"
              @refresh-members-table="refreshMembersTable"
            />
          </div>
        </Tab>
        <Tab
          v-if="isEditForm"
          title='<svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21.044 24.049" class="inline-block align-middle mr-1"><g id="Group_244" data-name="Group 244" transform="translate(-453.062 -37.45)"><path id="Path_109" data-name="Path 109" d="M463.593,50.506a6.528,6.528,0,1,0-6.529-6.528A6.546,6.546,0,0,0,463.593,50.506Zm-5.133-6.528a5.139,5.139,0,0,1,5.133-5.133l.133,0a5.135,5.135,0,1,1-5.266,5.135Z" fill="currentColor"/><path id="Path_110" data-name="Path 110" d="M463.584,50.727a10.534,10.534,0,0,0-10.522,10.522v.25h1.4v-.25a9.139,9.139,0,0,1,9.123-9.123h0a9.126,9.126,0,0,1,9.127,9.123v.25h1.15v-.25h.24A10.534,10.534,0,0,0,463.584,50.727Z" fill="currentColor"/></g></svg> <span class="align-middle">Group Event Admins</span>'
        >
          <div :class="$style.tabContent" class="pt-4">
            <Table
              ref="eventAdminsTable"
              :company-id="companyId"
              :group-id="groupId"
              :no-new-btn="true"
              :no-edit-btn="true"
              table-type="EVENT_ADMINS"
            />
            <AddEventAdmins
              :company-id="companyId"
              :group-id="groupId"
              @refresh-event-admins-table="refreshEventAdminsTable"
            />
          </div>
        </Tab>
        <Tab
          title='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000.23" fill="currentColor" height="24" width="24" class="inline-block align-middle mr-1"><title>Kyndhub edit icon</title><path d="M499.86,315.82c101.73,0,184.22,82.43,184.25,184.16v.09c0,101.73-82.43,184.22-184.16,184.25h-.09a184.25,184.25,0,0,1,0-368.5Zm0,52.65A131.58,131.58,0,1,0,631.55,500h0A131.6,131.6,0,0,0,500,368.42h-.09ZM805.4,693.93a26.29,26.29,0,0,1-4.62-31.2,338.44,338.44,0,0,0,26.76-65A26.32,26.32,0,0,1,852.73,579h94.44V421.12h-94.3a26.29,26.29,0,0,1-25.19-18.77,338.7,338.7,0,0,0-26.76-65,26.29,26.29,0,0,1,4.62-31.2l66.65-66.7L760.56,127.83l-66.79,66.79a26.31,26.31,0,0,1-31.16,4.63,341.46,341.46,0,0,0-65-26.81,26.35,26.35,0,0,1-18.76-25.24V52.81H420.91V147.2a26.35,26.35,0,0,1-18.77,25.24,342,342,0,0,0-65,26.81A26.3,26.3,0,0,1,306,194.62L239.35,128,127.67,239.46l66.65,66.65A26.33,26.33,0,0,1,199,337.32a337.57,337.57,0,0,0-26.77,65A26.3,26.3,0,0,1,147,421.07H52.46V579H146.9a26.32,26.32,0,0,1,25.19,18.77,338.44,338.44,0,0,0,26.76,65,26.29,26.29,0,0,1-4.62,31.2l-66.65,66.66L239.21,872.22l66.65-66.66A26.31,26.31,0,0,1,337,800.94,338,338,0,0,0,402,827.7a26.35,26.35,0,0,1,18.86,25.24v94.43h158V852.94a26.35,26.35,0,0,1,18.86-25.24,338,338,0,0,0,64.94-26.76,26.31,26.31,0,0,1,31.16,4.62l66.65,66.66L872.19,760.58Zm50.84-23.71L928,742a26.3,26.3,0,0,1,0,37.2h0L779.14,928.05a26.34,26.34,0,0,1-37.21,0l-71.78-71.78a392.43,392.43,0,0,1-38.6,15.85V973.81a26.35,26.35,0,0,1-26.3,26.31H394.61a26.35,26.35,0,0,1-26.3-26.31V872.12a392.43,392.43,0,0,1-38.6-15.85l-71.78,71.78a26.34,26.34,0,0,1-37.21,0L71.88,779.21a26.3,26.3,0,0,1,0-37.19l0,0,71.74-71.78a392.5,392.5,0,0,1-15.86-38.6H26.3A26.3,26.3,0,0,1,0,605.32H0V394.77a26.36,26.36,0,0,1,26.3-26.3H128a392.5,392.5,0,0,1,15.86-38.6L72.11,258.09a26.31,26.31,0,0,1,0-37.2h0L221,72a26.36,26.36,0,0,1,37.21,0l71.55,71.79a395.25,395.25,0,0,1,38.6-15.9V26.19A26.35,26.35,0,0,1,394.61-.12H605.16a26.36,26.36,0,0,1,26.3,26.31V127.88a395.25,395.25,0,0,1,38.6,15.9L741.84,72a26.36,26.36,0,0,1,37.21,0L927.89,220.88a26.3,26.3,0,0,1,0,37.19l0,0-71.74,71.78A392.5,392.5,0,0,1,872,368.47H973.7a26.36,26.36,0,0,1,26.3,26.3V605.32a26.3,26.3,0,0,1-26.3,26.3H872.19a390.36,390.36,0,0,1-16,38.6Z" transform="translate(0 0.12)" /></svg> <span class="align-middle">Settings</span>'
        >
          <div :class="$style.tabContent" class="pt-14">
            <div class="flex justify-center">
              <GroupSettings
                ref="groupSettings"
                :item-open="groupItem ? groupItem.open : 0"
                :company-id="companyId"
                :group-id="groupId"
                :is-edit-form="isEditForm"
                @refresh-admins-table="refreshAdminsTable"
              />
            </div>
            <div v-if="groupId" class="mt-10">
              <Table
                ref="adminsTable"
                :no-new-btn="true"
                :no-edit-btn="true"
                :company-id="companyId"
                :group-id="groupId"
                table-type="ADMIN_USERS"
              />
            </div>
          </div>
        </Tab>
      </Tabs>

      <div
        class="bg-white py-20 px-8 mx-7.5 rounded-xl rounded-t-none shadow-lg"
      >
        <div class="flex justify-center">
          <button
            class="button primary-button h-7.5 leading-relax text-sml rounded-small-button px-3.5"
            @click="saveEvent"
          >
            Save
          </button>
          <button
            class="button secondary-button h-7.5 leading-relax text-sml rounded-small-button px-3.5 ml-2"
          >
            <router-link :to="{ name: 'adminGroups' }">
              Return
            </router-link>
          </button>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
.tabContent {
  @apply bg-white mt-8 mx-7.5 px-8 rounded-xl rounded-b-none shadow-lg;
}
</style>
